import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Row from "./Row";
import { mainMaterialsTablesCols } from "./col";
import { IconButton, Skeleton } from "@mui/material";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export default function MaterialTable({ materials }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table" sx={{ border: "1px solid #ddd" }}>
        <TableHead>
          <TableRow
            sx={{ border: "1px solid #ddd", backgroundColor: "#f3f1fe" }}
          >
            <TableCell />
            {mainMaterialsTablesCols.map((col, i) => {
              return (
                <TableCell
                  key={col.header + i}
                  sx={{
                    fontweight: "bold",
                    fontSize: "17px",
                    border: "1px solid #ddd",
                  }}
                >
                  {col.header}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>

        <TableBody>
          {!materials?.[0]
            ? [1, 2, 3].map((i) => (
                <SkeletonRow cols={mainMaterialsTablesCols} key={i} />
              ))
            : materials.map((row) => <Row key={row.id} row={row} />)}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

function SkeletonRow({ cols }) {
  return (
    <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
      <TableCell sx={{ width: 50 }}>
        <IconButton
          aria-label="expand row"
          size="small"
          sx={{ mr: 1 }}
          disabled
        >
          <KeyboardArrowDownIcon />
        </IconButton>
      </TableCell>

      {cols.map((col) => {
        return (
          <TableCell sx={{ border: "1px solid #ddd" }} key={col.accessorKey}>
            <Skeleton variant="rounded" />
          </TableCell>
        );
      })}
    </TableRow>
  );
}
